import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Channel } from '@cuepid/core';
import { DirectMessageService } from '@cuepid/enterprise/core/services/direct-message.service';
import { InputMessageWithTemplateComponent } from '@cuepid/enterprise/shared/components/forms/message/input-message-with-template/input-message-with-template.component';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface DirectMessageDialogData {
  /** 採用タブ：既存チャネルへ一括送信（/company/me/message/bulk） */
  channels?: Channel[];
  /** 未処理／お気に入りタブ：採用前メッセージ送信（新規API） */
  campaignId?: number;
  influencerIds?: number[];
  /** 本文プレースホルダー（未指定時は呼び出し元に応じた既定値） */
  placeholder?: string;
}

@Component({
  selector: 'app-direct-message-dialog',
  templateUrl: './direct-message-dialog.component.html',
  styleUrls: ['./direct-message-dialog.component.scss'],
})
export class DirectMessageDialogComponent implements OnInit {
  @ViewChild('form') inputForm!: InputMessageWithTemplateComponent;

  readonly placeholder: string;

  constructor(
    private readonly messageService: DirectMessageService,
    private readonly ref: MatDialogRef<DirectMessageDialogComponent>,
    private readonly toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) private readonly data: DirectMessageDialogData
  ) {
    this.placeholder =
      this.data?.placeholder ??
      (this.isCampaignMessage()
        ? 'インフルエンサーに送るメッセージをご入力下さい'
        : '');
  }

  ngOnInit(): void {
    // 採用タブ（channel送信）でチャネルが空なら閉じる
    if (!this.isCampaignMessage() && !this.data?.channels?.length) {
      this.ref.close();
    }
  }

  cancel(): void {
    this.ref.close();
  }

  send(checkbox: MatCheckbox): void {
    if (this.inputForm.messageBodyControl.invalid || !checkbox.checked) {
      return;
    }

    const body = this.inputForm.messageBodyControl.value;
    const request$: Observable<unknown> = this.isCampaignMessage()
      ? this.messageService.sendCampaignMessage(
          this.data.campaignId as number,
          this.data.influencerIds ?? [],
          body
        )
      : this.messageService.sendMessageToMultiChannel(
          body,
          ...(this.data.channels ?? [])
        );

    request$
      .pipe(
        tap(() =>
          this.toastrService.info(
            this.isCampaignMessage()
              ? 'メッセージの送信に成功しました。'
              : 'チェック済みのインフルエンサーにメッセージを送信しました。'
          )
        )
      )
      .subscribe({
        next: () => this.ref.close(true),
        error: () =>
          this.toastrService.error('メッセージの送信に失敗しました。'),
      });
  }

  private isCampaignMessage(): boolean {
    return !!this.data?.campaignId;
  }
}
